import { IconProps } from '.';

const ExteriorIcon = ({
  color = 'var(--color-sage-300)',
  customClasses,
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 30 26"
      fill="none"
    >
      <path
        className={customClasses}
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66667 2.58325H12.0833V7.85994H0V10.3599H5.41667V15.6399H0V18.1399H15.4167V23.4166H1.66667V25.9166H26.6667V23.4166H17.9167V18.1399H30V15.6399H24.5833V10.3599H30V7.85994H14.5833V2.58325H26.6667V0.083252H1.66667V2.58325ZM22.0833 10.3599H7.91667V15.6399H22.0833V10.3599Z"
        fill={color}
      />
    </svg>
  );
};

export default ExteriorIcon;
